import { createAction } from 'typesafe-actions';

export const changeFloornMaxAction = createAction('filters/maxFloornChanged')<number>();
